import { useDropzone } from "react-dropzone";

export default function PdfUploader({
  onDrop,
}) {
  const {
    getRootProps,
    getInputProps,
    isDragActive,
  } = useDropzone({
    accept: {
      "application/pdf": [".pdf"],
    },

    onDrop,
  });

  return (
    <div
      {...getRootProps()}
      className="pdf-upload-box"
    >
      <input {...getInputProps()} />

      {isDragActive ? (
        <p>
          Drop PDF files here...
        </p>
      ) : (
        <p>
          Drag & Drop PDF files
          here or click to upload
        </p>
      )}
    </div>
  );
}